// extracted by mini-css-extract-plugin
export default {"backdrop":"styles_backdrop__pNKt2","loaderContainer":"styles_loaderContainer__B9HvH","text":"styles_text__MZnbW","loader":"styles_loader__Ucfqs","loading":"styles_loading__PV0aT"};